import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { FaCertificate } from 'react-icons/fa';
import flutterCertificate from '../assets/flutter-full-stack-certificate.jpg';
import githubFoundations from '../assets/github-foundations.jpg';
import googleAiFundamentals from '../assets/google-ai-fundamentals.jpg';
import googlePlayAcademy from '../assets/google-play-academy.jpg';
import nasaOpenScience from '../assets/nasa-open-science-101.jpg';

const certifications = [
  { name: 'NASA Open Science 101', issuer: 'NASA', date: 'August 17, 2026', image: nasaOpenScience, link: 'https://www.credly.com/badges/da6281df-8577-460a-82ee-d6e368b765d8/linked_in_profile' },
  { name: 'GitHub Foundations', issuer: 'DataCamp', date: 'September 25, 2026', image: githubFoundations },
  { name: 'Google Play Academy - Store Listing Certificate', issuer: 'Google Play Academy', date: 'September 20, 2026 · Valid through September 20, 2029', credentialId: '194637322', image: googlePlayAcademy, link: 'https://www.credential.net/5f30b409-2fb4-4b56-aa2a-b8dcaf2aaf3e#acc.yD7uczra' },
  { name: 'Google AI Fundamentals', issuer: 'Coursera', date: 'September 23, 2026', image: googleAiFundamentals, link: 'https://www.credly.com/badges/81dc2437-7b17-4b68-879b-294af5d03e99/linked_in_profile' },
  { name: 'Flutter Full Stack Development', issuer: 'Jawan Pakistan · WOW Education Valley', date: 'September 2021 - February 2022', image: flutterCertificate },
];

export default function Certifications() {
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    if (!selectedImage) return undefined;
    const closeOnEscape = event => event.key === 'Escape' && setSelectedImage(null);
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [selectedImage]);

  return (
    <section className="px-4 py-16 sm:px-6 sm:py-24 lg:px-8" id="certifications">
      <div className="site-container">
        <div className="mb-8 max-w-2xl sm:mb-12">
          <p className="section-eyebrow">Certifications</p>
          <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-white sm:text-5xl">Continuous learning.</h2>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {certifications.map(certification => (
            <article key={certification.name} className="surface-card overflow-hidden p-3 transition hover:border-slate-500">
              <button type="button" onClick={() => setSelectedImage(certification)} className="focus-ring block w-full overflow-hidden rounded-xl bg-slate-950 text-left" aria-label={`Preview ${certification.name} image`}>
                <img src={certification.image} alt={`${certification.name} certificate`} className="block h-52 w-full object-contain transition duration-300 hover:scale-[1.02] sm:h-56" />
              </button>
              <div className="flex items-start gap-4 p-3 pb-2">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-slate-700 bg-slate-900 text-cyan-300"><FaCertificate aria-hidden="true" /></span>
              <div>
                <h3 className="pt-1 text-sm font-bold leading-6 text-white">{certification.name}</h3>
                {certification.issuer && <p className="mt-1 text-xs text-slate-500">Issued by {certification.issuer}</p>}
                {certification.date && <p className="mt-1 text-xs leading-5 text-slate-500">{certification.date}</p>}
                {certification.credentialId && <p className="mt-1 text-xs text-slate-600">Credential {certification.credentialId}</p>}
                {certification.link && <a href={certification.link} target="_blank" rel="noopener noreferrer" className="focus-ring mt-3 inline-flex rounded-full border border-slate-700 px-3 py-1.5 text-xs font-bold text-cyan-200 transition hover:border-cyan-300/60">View credential</a>}
              </div>
              </div>
            </article>
          ))}
        </div>
      </div>
      {selectedImage && createPortal(
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/90 p-4 backdrop-blur-sm" role="presentation" onMouseDown={event => event.target === event.currentTarget && setSelectedImage(null)}>
          <div role="dialog" aria-modal="true" aria-labelledby="certificate-preview-title" className="relative max-h-[92vh] w-full max-w-4xl overflow-auto rounded-2xl border border-slate-700 bg-[#0d1117] p-3 shadow-2xl">
            <div className="flex items-center justify-between gap-4 p-3">
              <h2 id="certificate-preview-title" className="text-sm font-bold text-white">{selectedImage.name}</h2>
              <button type="button" onClick={() => setSelectedImage(null)} className="focus-ring rounded-full border border-slate-700 px-3 py-1.5 text-xs font-bold text-slate-300 hover:text-white" aria-label="Close certificate preview">Close</button>
            </div>
            <img src={selectedImage.image} alt={`${selectedImage.name} full preview`} className="mx-auto max-h-[78vh] w-full object-contain" />
          </div>
        </div>
        , document.body
      )}
    </section>
  );
}
